
import React, { FC, JSX } from "react";
import ExternalCandidatesTable from "../../components/externalCandidates/ExternalCandidatesTable";

const AgentExternalCandidates: FC = (): JSX.Element => {
  return (
    <ExternalCandidatesTable
      isAdminView={false}
      pageTitle="External Candidates"
      pageDescription="Search and manage external candidates from various sources"
    />
  );
};

export default AgentExternalCandidates;
